import React from 'react';
import { LegalLayout } from '../components/legal/LegalLayout';

const SECTIONS = [
  {
    heading: 'Using Vyvre',
    body: [
      'Vyvre is a creator intelligence and campaign operations platform for brands, agencies, talent managers and creators. By creating an account or using the platform you agree to these terms.',
      'You must provide accurate information and keep your login credentials secure. You are responsible for activity that takes place under your account.',
    ],
  },
  {
    heading: 'Campaigns & Content',
    body: [
      'Brands and agencies are responsible for the accuracy of their briefs, mandates and budgets. Creators are responsible for the content they publish and for complying with applicable advertising disclosure rules.',
      'Costs, deliverables and timelines confirmed on the platform form the basis of each campaign engagement between the parties involved.',
    ],
  },
  {
    heading: 'Acceptable Use',
    body: [
      'Do not misuse the platform: no unlawful content, spam, scraping, attempts to access data you are not authorised to see, or interference with the service.',
      'We may suspend or terminate accounts that violate these terms.',
    ],
  },
  {
    heading: 'Intellectual Property',
    body: [
      'The Vyvre platform, brand and software belong to Vyvre. Content uploaded by users remains theirs; you grant us the limited rights needed to operate the platform and deliver campaigns.',
    ],
  },
  {
    heading: 'Liability',
    body: [
      'The platform is provided "as is". To the extent permitted by law, Vyvre is not liable for indirect or consequential losses arising from use of the platform.',
      'These terms are governed by the laws of India, with courts in Mumbai having jurisdiction.',
    ],
  },
  {
    heading: 'Contact Us',
    body: ['Questions about these terms? Email hello@vyvre.in.'],
  },
];

export default function TermsOfService() {
  return (
    <LegalLayout
      testid="terms-page"
      title="Terms of Service — Vyvre"
      updated="October 2026"
      intro="These terms govern your access to and use of the Vyvre platform."
      sections={SECTIONS}
    />
  );
}
